module.exports = __webpack_public_path__ + "images/car.a1e116f10b997188691d94e78d85fc59.svg";